import { useEffect, useState, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import ClientContext from 'contexts/ClientContext'
import PageTitle from 'components/common/PageTitle/PageTitle'
import PageSubtitle from 'components/common/PageSubtitle/PageSubtitle'
import InfoMessage from 'components/common/InfoMessage/InfoMessage'
import ShieldLogo from 'components/assets/icons/ShieldLogo'
import Arrow from 'components/assets/icons/Arrow'
import Card from 'components/common/Card/Card'
import api from 'helpers/api'
import Button from 'components/common/Button/Button'
import style from './ClaimList.module.scss'
import Thundercloud from 'components/assets/icons/Thundercloud'
import Status from 'components/common/Status/Status'
import { useNavigate } from 'react-router-dom'
import { CLAIM_STATUSES } from 'constants/contract'
import ShieldStar from 'components/assets/icons/ShieldStar'

const ClaimList = () => {
  const { t, i18n: { language } } = useTranslation()
  const navigate = useNavigate()
  const { isColabelAllowed, contractTypeId, partnerId, distributorId, color, colabelNeutralDark } = useContext(ClientContext)

  const [claims, setClaims] = useState([])

  const { APPROVED, INCOMPLETE, CLOSED } = CLAIM_STATUSES

  useEffect(() => {
    const getClaims = async () => {
      if (isColabelAllowed && !contractTypeId) return
      try {
        const res = isColabelAllowed
          ? await api.get({ url: `/claims/${contractTypeId}/${partnerId}/${distributorId}` })
          : await api.get({ url: '/claims' })
        setClaims(res)
      } catch (error) {
        console.log('Fetch claims error')
      }
    }
    getClaims()
  }, [isColabelAllowed, contractTypeId, partnerId, distributorId, language])

  const dateFormat = (date) => {
    const day = ('0'+date.getDate()).slice(-2)
    const month = ('0'+Number(date.getMonth() + 1)).slice(-2)
    const year = date.getFullYear()
    return `${day}/${month}/${year}`
  }

  return (
    <>
      <PageTitle text={t('claim:list.title')} />
      <PageSubtitle text={t('claim:list.subtitle')} />
      <InfoMessage
        className={style['info-message']}
        label={t('claim:infoMessage')}
        prefix={color ? <ShieldStar styles={{fill: colabelNeutralDark}} /> : <ShieldLogo />}
        suffix={
          <Button
            className={style['claim-button']}
            label={t('claim:ctaInfinitive')}
            onClick={() => navigate('/claims/new')}
            type="primary"
          />
        }
      />
      <div className={style.items}>
        {(!claims || !claims?.length) && <div className={style['empty-list-message']} style={color && {color: colabelNeutralDark}}>{t('claim:list.empty')}</div>}
        {!!claims?.length &&
          claims.map((item, index) => {
            return (
              <Card
                className={style.item}
                inactive={item.cancelation}
                content={
                  <div className={style['item-content']}>
                    <div>
                      {t('claim:item.nature')} <span>{item.nature.name}</span>
                      <br/>{t('claim:item.declarationDate')} <span>{dateFormat(new Date(item.createdAt))}</span>
                      <br/>#{item.shortId}
                    </div>
                    <Status
                      label={t(`claim:item.status.${item.status}`)}
                      type={
                        item.status === APPROVED
                          ? 'success'
                          : item.status === INCOMPLETE || item.status === CLOSED
                          ? 'error'
                          : 'warning'
                      }
                    />
                  </div>
                }
                key={`contract-item-${index}`}
                onClick={() => navigate(item._id, { state: { claim: item } })}
                title={item.name}
                titleIcon={<Thundercloud styles={{ fill: color ? colabelNeutralDark : '#1414FF' }} />}
                cornerContent={<Arrow styles={color && {fill: colabelNeutralDark}} />}
              />
            )
          })}
      </div>
    </>
  )
}

export default ClaimList
